import { createActions, createReducer } from "reduxsauce";
import { set, cloneDeep, forEach, isEmpty } from "@utils/lodash";
import moment from "moment";
import { USER_TYPE } from "@constants";

export { default as thunks } from "./thunks";

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	reportType: "",
	renderReport: false,
	agencies: [],
	clients: [],
	projects: [],
	locations: [],
	contacts: [],
	filters: {
		startDateRange: moment().subtract({ days: 1 }),
		endDateRange: moment(),
		agencyId: "",
		clientId: "",
		projectId: "",
		locationId: "",
		clientSupervisorContactId: "",
		officerId: "",
		jurisdictionId: "",
		includeAll: false,
	},
	loaders: {
		agencies: false,
		clients: false,
		projects: false,
		locations: false,
		contacts: false,
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions(
	{
		receiveData: ["collection"],
		updateLoaders: ["loader", "value"],
		updateFilters: ["collection"],
		resetFilters: ["userTypeId"],
	},
	{ prefix: "@reports/" },
);

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA]: (state, { collection }) => {
		if (!isEmpty(collection)) {
			const newState = cloneDeep(state);

			forEach(collection, ({ property, value }) => {
				set(newState, property, value);
			});

			return newState;
		}
		return state;
	},

	[Types.UPDATE_LOADERS]: (state, { loader, value }) => ({
		...state,
		loaders: {
			...state.loaders,
			[loader]: value,
		},
	}),

	[Types.UPDATE_FILTERS]: (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, ({ property, value }) => {
			set(newState, ["filters", property], value);
		});

		return newState;
	},

	[Types.RESET_FILTERS]: (state, { userTypeId }) => {
		const newState = cloneDeep(INITIAL_STATE);

		if (!userTypeId) return newState;

		if (userTypeId === USER_TYPE.SUPER_ADMIN) newState.agencies = state.agencies;
		else if (userTypeId === USER_TYPE.CLIENT)
			newState.filters.clientId = state.filters.clientId;
		else if (userTypeId === USER_TYPE.LAW_ENFORCEMENT) {
			newState.clients = state.clients;
			newState.filters.jurisdictionId = state.filters.jurisdictionId;
		} else {
			newState.filters.agencyId = state.filters.agencyId;
			newState.clients = state.clients;
		}

		return newState;
	},
});

export default Creators;
